module.exports = __webpack_public_path__ + "img/map-background.91474408.png";